/* eslint-disable */
// tslint:disable
/**
 * Isletnet API
 *  # Islets  Rest API for [IsletNet](http://isletnet.com/) - an accurate neural network based tool for automated segmentation and analysis  of pancreatic (Langerhans) islets. For more information, see the IsletNet [User guide](http://isletnet.com/guide) or try the tool at  [www.isletnet.com](http://isletnet.com/).  Both IsletNet and this API serve for two main usecases:  ## Analysis   The main usecase.   User submits a request:   - images of the tissue AND/OR own segmentations (can be mixed) - user input data (information about batch of images)   The API returns the response containing: - automated segmentation of islets for each submitted image of the tissue  - histogram of islet size distribution for each image - results of the analysis (both detailed results per image and overall summary)  ## Validation  The usecase to assess the accuracy of one\'s own segmentation by submitting both the segmentation and the  original image. The API returns the comparison of his segmentation to the automated one, returning both  visual and statistical summary.  User submits a request:  - image&own_segmentation (mask) pairs  The API returns the response containing: - results of validation against the automated segmentation - visual comparison 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ComparisonMaskStatistics,
    ComparisonMaskStatisticsFromJSON,
    ComparisonMaskStatisticsFromJSONTyped,
    ComparisonMaskStatisticsToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComparisonResult
 */
export interface ComparisonResult {
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    contoursId: string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    contoursLabeledId: string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    ellipsesId: string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    histogramId: string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    imageContoursExoId: string;
    /**
     * 
     * @type {number}
     * @memberof ComparisonResultResponse
     */
    isletCountUser: number;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    maskCombinedId: string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    maskExoColorId: string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    maskExoId: string;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    maskIsletsId: string;
    /**
     * 
     * @type {ComparisonMaskStatistics}
     * @memberof ComparisonResultResponse
     */
    maskStatistics: ComparisonMaskStatistics;
    /**
     * 
     * @type {string}
     * @memberof ComparisonResultResponse
     */
    methodUser: string;
    /**
     * 
     * @type {number}
     * @memberof ComparisonResultResponse
     */
    purityUser: number;
    /**
     * 
     * @type {number}
     * @memberof ComparisonResultResponse
     */
    volumeUser: number;
}

export function ComparisonResultFromJSON(json: any): ComparisonResult {
    return ComparisonResultFromJSONTyped(json, false);
}

export function ComparisonResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComparisonResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contoursId': json['contours_id'],
        'contoursLabeledId': json['contours_labeled_id'],
        'ellipsesId': json['ellipses_id'],
        'histogramId': json['histogram_id'],
        'imageContoursExoId': json['image_contours_exo_id'],
        'isletCountUser': json['islet_count_user'],
        'maskCombinedId': json['mask_combined_id'],
        'maskExoColorId': json['mask_exo_color_id'],
        'maskExoId': json['mask_exo_id'],
        'maskIsletsId': json['mask_islets_id'],
        'maskStatistics': ComparisonMaskStatisticsFromJSON(json['mask_statistics']),
        'methodUser': json['method_user'],
        'purityUser': json['purity_user'],
        'volumeUser': json['volume_user'],
    };
}

export function ComparisonResultToJSON(value?: ComparisonResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contours_id': value.contoursId,
        'contours_labeled_id': value.contoursLabeledId,
        'ellipses_id': value.ellipsesId,
        'histogram_id': value.histogramId,
        'image_contours_exo_id': value.imageContoursExoId,
        'islet_count_user': value.isletCountUser,
        'mask_combined_id': value.maskCombinedId,
        'mask_exo_color_id': value.maskExoColorId,
        'mask_exo_id': value.maskExoId,
        'mask_islets_id': value.maskIsletsId,
        'mask_statistics': ComparisonMaskStatisticsToJSON(value.maskStatistics),
        'method_user': value.methodUser,
        'purity_user': value.purityUser,
        'volume_user': value.volumeUser,
    };
}


